module.exports = __webpack_public_path__ + "img/supster.17db3397.svg";